import ImageUploadDrag from '../../src/legacy/ImageUploadDrag.tsx';
export default ImageUploadDrag;
